import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Alert, AlertType } from './alert.model';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class AlertService {
    private subject = new Subject<Alert>();
    private defaultId = 'default-alert';
    private readonly swalConfig = {
      confirmButtonColor: '#337ab7',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel'
    };
      constructor(private toastr: ToastrService) {}

    // enable subscribing to alerts observable
    onAlert(id = this.defaultId): Observable<Alert> {
        return this.subject.asObservable().pipe(filter(x => x && x.id === id));
    }

    // convenience methods
    success(message: string, options?: any) {
      this.clear();
        this.alert(new Alert({ ...options, type: AlertType.Success, message }));
    }

    error(message: string, options?: any) {
      this.clear();
        this.alert(new Alert({ ...options, type: AlertType.Error, message }));
    }

    info(message: string, options?: any) {
      this.clear();
        this.alert(new Alert({ ...options, type: AlertType.Info, message }));
    }

    warn(message: string, options?: any) {
      this.clear();
        this.alert(new Alert({ ...options, type: AlertType.Warning, message }));
        
    }

    // main alert method
    alert(alert: Alert) {
        alert.id = alert.id || this.defaultId;
        this.subject.next(alert);
    }

    // clear alerts
    clear(id = this.defaultId) {
        this.subject.next(new Alert({ id }));
    }
    // ---------- ALERT HELPERS ----------
    showSuccess(message: string) {
          this.toastr.success(message);
    }
  
    showError(message: string) {
      this.toastr.error(message)
    }
  
    showWarning(message: string) {
      this.toastr.warning(message);
    }

    showConfirm(message: string): Promise<boolean> {
      return Swal.fire({
        title: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#337ab7',
        cancelButtonColor: '#d33'
      }).then(result => result.value === true);
    }
    showConfirmation(title:string,message: string): Promise<boolean> {
      return Swal.fire({
        title: title,
        text: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#337ab7',
        cancelButtonColor: '#d33'
      }).then(result => result.value === true);
    }
}
